<template>
  <v-card class="card--mirror mb-0">
    <div class="card-content px-3 pb-0">
      <div class="content-header d-flex align-center justify-space-between">
        <div class="d-flex align-center mb-3" style="min-width: fit-content">
          <div>
            <v-chip :class="`item-type-display ${activityType}`" label dark>
              {{ itemTypeDisplay(activityType) }}
            </v-chip>
          </div>
          <div class="ml-4">
            <div class="sub-title">
              Retranca
            </div>
            <div class="slug-title">
              {{ slug.title || emptyField }}
            </div>
          </div>
        </div>
        <div class="card-content-metadata">
          <div
            class="card-content-metadata__item"
            v-for="data in metadata"
            :key="data.name"
          >
            <div>{{ data.name }}</div>
            <div>{{ data.value }}</div>
          </div>
        </div>
        <div class="content-header-time">
          <v-icon>access_time</v-icon>
          <div class="time">
            {{ startTime }}
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatSeconds } from '@/utils/date.js';
import { formatField, itemTypeDisplay } from '@/utils/mirrorFormatter.js';
import { mapState } from 'vuex';

export default {
  name: 'MirrorDetailsCard',
  props: {
    slug: Object,
    activityType: String,
  },
  data() {
    return {
      emptyField: '--',
    };
  },
  computed: {
    ...mapState({
      selectedMirror: state => state.mirror.selectedMirror,
    }),

    metadata() {
      const {
        reporter,
        presenter,
        speaking_time,
        tape_time,
        total_time,
        ori,
        video_id,
        page,
      } = this.slug;

      const formatMetadata = value =>
        this.formatSeconds(value) || this.emptyField;

      return [
        { name: 'PG', value: page || this.emptyField },
        { name: 'Ori', value: ori || this.emptyField },
        { name: 'Rep', value: reporter || this.emptyField },
        { name: 'LOC', value: this.formatField(presenter) },
        { name: 'tCAB', value: formatMetadata(speaking_time) },
        { name: 'tVT', value: formatMetadata(tape_time) },
        { name: 'tMAT', value: formatMetadata(total_time) },
        { name: 'Mídia', value: video_id },
      ];
    },
    startTime() {
      if (this.slug && this.slug.start_time)
        return this.formatSeconds(this.slug.start_time, true);
      return '---';
    },
  },

  methods: {
    formatSeconds,
    itemTypeDisplay,
    formatField,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/mirror-card.scss';

.content-header {
  width: 100%;
}
.sub-title {
  font-size: 0.7em !important;
  font-style: italic;
  color: $color-black-80;
  text-transform: uppercase;
}

.slug-title {
  font-family: 'globotipo' !important;
  font-weight: 700 !important;
  font-size: 1.2em !important;
  font-style: italic;
  color: $color-black-80;
  text-transform: uppercase;
}

.item-type-display {
  font-family: 'globotipo' !important;
  font-weight: 500 !important;
  font-size: 0.8em;
  text-transform: uppercase;

  &.live {
    background-color: $status-live;
  }
  &.studio {
    background-color: $status-studio;
  }
  &.vt {
    background-color: $status-vt;
  }
  &.screen {
    background-color: $status-screen;
  }
  &.others {
    background-color: $status-others;
  }
}
.content-header-time {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  margin: 0;
  color: $color-black-40;
  margin: 0 16px 0 0;

  .v-icon {
    font-size: 1.2em;
    margin: 0 2px 0 0;
    opacity: 0.4;
  }

  .time {
    font-family: 'globotipo' !important;
    font-weight: 600 !important;
    font-size: 1em;
    color: $color-black-64;
    margin: 2px 0 0 2px;
  }
}
</style>
